import {
  LayoutDashboard, Ticket, Flag, BarChart3, Users, Megaphone, Swords, Sparkles,
  Gauge, Share2, FileBarChart, FolderKanban, UsersRound,
} from "lucide-react";

export const STAFF_NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/clients", label: "Clients", icon: Users },
  { to: "/tickets", label: "Tickets", icon: Ticket },
  { to: "/projects", label: "Projects", icon: FolderKanban },
  { to: "/reports", label: "Reports", icon: FileBarChart },
  { to: "/milestones", label: "Milestones", icon: Flag },
  { to: "/seo", label: "SEO Reports", icon: BarChart3 },
  { to: "/toolkit", label: "SEO Toolkit", icon: Gauge },
  { to: "/marketing", label: "Marketing", icon: Megaphone },
  { to: "/competitors", label: "Competitors", icon: Swords },
  { to: "/content", label: "AI Content", icon: Sparkles },
  { to: "/social", label: "Social Studio", icon: Share2 },
];

export const CLIENT_NAV = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/tickets", label: "Tickets", icon: Ticket },
  { to: "/projects", label: "Projects", icon: FolderKanban },
  { to: "/reports", label: "Reports", icon: FileBarChart },
  { to: "/milestones", label: "Milestones", icon: Flag },
  { to: "/seo", label: "SEO Reports", icon: BarChart3 },
  { to: "/toolkit", label: "SEO Toolkit", icon: Gauge },
  { to: "/marketing", label: "Marketing", icon: Megaphone },
  { to: "/competitors", label: "Competitors", icon: Swords },
  { to: "/content", label: "AI Content", icon: Sparkles },
  { to: "/social", label: "Social Studio", icon: Share2 },
];

export function buildNavItems(role) {
  const base = role === "client" ? CLIENT_NAV : STAFF_NAV;
  return role === "admin"
    ? [...base, { to: "/users", label: "Team & Users", icon: UsersRound }]
    : base;
}
